import { email, phone } from '@lib/regexes'
import * as Yup from 'yup'

// Also used on the RCPO section of the website
export const schema = Yup.object().shape(
  {
    gender: Yup.string().required('contactForm.errorGender'),
    firstName: Yup.string().required('contactForm.errorFirstName'),
    lastName: Yup.string().required('contactForm.errorLastName'),
    email: Yup.string()
      .matches(email, 'contactForm.errorEmail')
      .when('phone', {
        is: (phone: string) => Boolean(!phone),
        then: (schema) => schema.required('contactForm.errorEmail'),
      }),
    countryCode: Yup.string(),
    phone: Yup.string()
      .matches(phone, 'contactForm.errorPhone')
      .when('email', {
        is: (email: string) => Boolean(!email),
        then: (schema) => schema.required('contactForm.errorPhone'),
      }),
    location: Yup.string(),
    store: Yup.string(),
    message: Yup.string(),
    agree: Yup.bool().oneOf([true], 'contactForm.errorPrivacy'),
    subscribe: Yup.boolean(),
  },
  [['email', 'phone']],
)
